<template>
	<div>
		<div class="data1">
			<div class="data1Left" :style="{
				paddingLeft:bj+'px'
			}">
				<div class="data1LeftOne">{{list.data.menuTitle}}</div>
				<div class="data1LeftTwo">
					<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
				</div>
				<div class="data1LeftThree">
					<div v-for="(item,index) in list.data.content" :key="index">{{item.text}}</div>
				</div>
			</div>
			<div class="data1Right">
				<!-- <img src="@/assets/product/njysddlzs.png" /> -->
				<div class="swiper-data1-banner" :class="`swiper-data1-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.videos" :key="index">
							<!-- <video :src="item" :autoplay="true" muted loop :style="{
								height:list.data.height+'px'
							}"></video> -->
							<template v-if="headerShow">
								<video :src="item" :autoplay="true" webkit-playsinline playsinline x5-video-player-type="h5-page" muted loop :style="{
								height:list.data.height+'px'
							}"></video>
							</template>
							<template v-else>
								<video :src="item" webkit-playsinline playsinline x5-video-player-type="h5-page" muted loop :style="{
								height:list.data.height+'px'
							}" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
							</template>
							<!-- <img :src="item.img" />
						<div class="swiper-slide-dw" :class="activeIndex==index?' ':''" style="animation-duration: 1s;">
							<div class="swiper-slide-dw-name">{{item.name}}</div>
							<div class="swiper-slide-dw-cen">
								{{item.cen}}
							</div>
							<div class="swiper-slide-dw-cenen">{{item.cenEn}}</div>
						</div> -->
						</div>
					</div>
					<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.videos.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				qhShow:true,
				activeIndex: 0,
				bj: ''
				// list:[
				// 	{
				// 		img:require('@/assets/product/njysddlzs.png'),
				// 	},
				// 	{
				// 		img:require('@/assets/product/njysddlzs.png'),
				// 	}
				// ]
			}
		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		mounted() {
			let t = this;
			t.getWidth();
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			let name = '.swiper-data1-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				allowTouchMove: this.list.data.videos.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.videos.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.videos.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.videos.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data1 {
		display: flex;
		align-items: center;
		margin-bottom: 150px;
		width: 100%;
		justify-content: space-between;

		.data1Left {
			flex: 1;
			padding-left: 200px;

			.data1LeftOne {
				font-size: 45px;
				
				font-weight: bold;
				color: #000000;
				margin-bottom: 60px;
			}

			.data1LeftTwo {
				font-size: 18px;
				
				font-weight: 300;
				color: #000000;
				margin-bottom: 71px;
				line-height: 30px;

				>div {
					white-space: pre-line;
				}
			}

			.data1LeftThree {
				font-size: 18px;
				
				font-weight: 300;
				color: #000000;
				line-height: 50px;

				>div {
					white-space: pre-line;
				}
			}
		}

		.data1Right {
			margin-left: 40px;
			width: 50%;
			// height: 600px;
			// background-color: #000;
			// img{
			// 	width: 100%;
			// 	height: 100%;
			// 	object-fit: cover;
			// }
		}
	}

	.swiper-data1-banner {
		overflow: hidden;
		// background-color: #000000;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
		.swiper-slide33 {
			width: 580px;
		}
	}

	.swiper-slide {
		position: relative;

		img {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 100%;
			height: 600px;
			object-fit: contain;
		}
	}

	@media screen and (max-width:1200px) {
		.data1 {
			margin-bottom: 0px !important;
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			flex-wrap: wrap;

			.data1Left {
				min-width: 100% !important;
				padding-left: 0 !important;

				.data1LeftOne {
					font-size: 24px !important;
					margin-bottom: 20px !important;
				}

				.data1LeftTwo {
					font-size: 14px !important;
					margin-bottom:0px !important;
				}

				.data1LeftThree {
					font-size: 14px !important;
					line-height: 30px !important;
					margin-bottom: 20px !important;
				}
			}

			.data1Right {
				margin-left: 0px !important;
				width: 100% !important;
				// height: 600px;
				// background-color: #000;
				// img{
				// 	width: 100%;
				// 	height: 100%;
				// 	object-fit: cover;
				// }
			}
		}

		.swiper-slide {
			img {
				height: auto !important;
			}

			video {
				height: auto !important;
			}
		}
		.swiper-data1-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>